import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { key: 0 }

import {
  ref,
  PropType,
  computed,
  watch,
  Ref,
  unref,
  nextTick,
  toRaw,
} from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import { addRole, updateRole, getMenus } from '@/api/common'
import { ElMessage, ElMessageBox } from 'element-plus'
import FormRulesFactory from '@/common/formRules'
import useProtocolEnums from '@/hooks/useProtocolEnums'


import { defineComponent, defineExpose } from 'vue'

const __default__ = defineComponent({
  name: 'UpsertRoleDrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  role: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const roleFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['name', 'desc'], 'inputEmpty', 'inputInvalid'),
})
const { defaultRoleTypes } = useProtocolEnums()

const { t, tl } = useI18nTl('Operation')



let subsForm = ref()
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    })
  })
}
const record = ref<Record<string, any>>({
  enable: true,
  menuIds: [],
})
const menuSelectedTree = ref()
const showAllMenus = ref([])
const hitMenuIds = ref<Array<string>>([])

const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      subsForm.value?.clearValidate()
      record.value = {}
    }
  },
})

const loadHitMenusData = async () => {
  console.log('编辑+++++++++++++loadHitMenusData')
  console.log('编辑传过来的当前条数据', props.role)
  if (props.role.id == 1) {
    return
  }
  try {
    const { menus = [] } = await getMenus({ roleID: props.role?.id })
    hitMenuIds.value = getHitIds({ children: menus })
    nextTick(() => {
      unref(menuSelectedTree).setCheckedKeys(hitMenuIds.value)
    })
    console.log('hitMenuIds', hitMenuIds.value)
  } catch (error) {
    console.error('Failed to load hit menus:', error)
  }
}

const loadAllMenusData = async () => {
  console.log('编辑+++++++++++++loadAllMenusData')
  if (props.role.id == 1) {
    return
  }
  showAllMenus.value = []
  hitMenuIds.value = []
  try {
    const { menus = [] } = await getMenus()
    showAllMenus.value = menus
    hitMenuIds.value = getHitIds({ children: [] })
    // nextTick(() => {
    //   unref(menuSelectedTree).setCheckedKeys(hitMenuIds.value)
    // })
  } catch (error) {
    console.error('Failed to load menus:', error)
  }
}

function getHitIds(menu: any): Array<string> {
  let hitIds = []
  if (menu.type !== 'menugroup') {
    hitIds.push(menu.id)
  }
  if (menu.children) {
    for (let child of menu.children) {
      hitIds = hitIds.concat(getHitIds(child))
    }
  }
  return hitIds
}

const submit = async () => {
  console.log('编辑或新增的数据')
  await subsForm.value?.validate()

  const selectedNodes = menuSelectedTree.value.getCheckedNodes()
  const selectnodeArray = JSON.parse(JSON.stringify(selectedNodes))
  const selectarray: any[] = []

  selectnodeArray.forEach((node: any) => {
    console.log('node', node, node.id)
    selectarray.push(node.id)

    if (node.pid != '0') {
      selectarray.push(...node.deepPath)
    }
  })
  const uniqueSortedArray = [...new Set(selectarray)].sort((a, b) => a - b)

  record.value.menuIds = uniqueSortedArray
  if (props.isEdit) {
    updateRole(record.value).then((res: any) => {
      ElMessage.success(t(`Base.editSuccess`))
      showDialog.value = false
      emit('submitted')
    })
  } else {
    addRole(record.value).then((res: any) => {
      ElMessage.success(t(`Base.createSuccess`))
      showDialog.value = false
      emit('submitted')
    })
  }
}

watch(
  () => props.modelValue,
  async (val) => {
    console.log('props.modelValue', props.modelValue, 'props.isEdit', props.isEdit)
    if (props.modelValue) {
      // await loadAllMenusData()
      // await loadHitMenusData()
    }
    if (props.isEdit) {
      await loadAllMenusData()
      await loadHitMenusData()
      record.value.id = props.role?.id
      record.value.name = props.role?.name
      record.value.desc = props.role?.desc
      record.value.enable = props.role?.enable
      record.value.menuIds = props.role?.menuIds
      record.value.roleType = props.role?.roleType
    } else {
      await loadAllMenusData()
      record.value = {}
      record.value.enable = true
    }
  },
  { immediate: true },
)
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: props.isEdit ? _unref(t)('Base.roleEdit') : _unref(t)('Base.roleAdd'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.saveChanges')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: roleFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.name'),
                    prop: "name",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.type'),
                    prop: "roleType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.roleType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.roleType) = $event)),
                        placeholder: _ctx.$t('Operation.chooseAdo')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(defaultRoleTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.ban'),
                    prop: "enable",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                modelValue: record.value.enable,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.enable) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.desc'),
                    prop: "desc",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: record.value.desc,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.desc) = $event)),
                        rows: 3
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.showMenus'),
                    prop: "menuIds"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { style: {"width":"100%","min-height":"100px"} }, {
                        default: _withCtx(() => [
                          (props.role.id == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('Base.superRolePerm')), 1))
                            : (_openBlock(), _createBlock(_component_el_tree, {
                                key: 1,
                                ref_key: "menuSelectedTree",
                                ref: menuSelectedTree,
                                data: showAllMenus.value,
                                props: { children: 'children', label: 'title' },
                                "default-expand-all": true,
                                "default-checked-keys": hitMenuIds.value,
                                "show-checkbox": "",
                                "node-key": "id"
                              }, {
                                default: _withCtx(({ node }) => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`components.${node.label}`)), 1)
                                ]),
                                _: 1
                              }, 8, ["data", "default-checked-keys"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})